
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store",
      function () {
        return require("private-next-pages/[lang]/store/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store"])
      });
    }
  